export enum ClientType {

  FINAL	= 'FINAL',
  FINAL_NATIONAL_ASSO = 'FINAL_NATIONAL_ASSO',
  FINAL_INTERNATIONAL = 'FINAL_INTERNATIONAL'	,
  INTERMEDIAIRE    =   'INTERMEDIAIRE' ,
  INTERNE       =    'INTERNE',
}


export enum FrenchClientType {
  FINAL	= 'Final',
  FINAL_NATIONAL_ASSO = 'Final national asso ou mécénat',
  FINAL_INTERNATIONAL = 'Final international'	,
  INTERMEDIAIRE    =   'Intermédiaire' ,
  INTERNE       =    'Interne',
}
